import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../../shared/services/appsettings.service';
import { AuthenticationService } from '../../authModule/services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'DartStudentArtGallery';

  ngOnInit(): void {
  }

  constructor(private appSettingsService: AppSettingsService,
    private authService: AuthenticationService) {
  }

}
